<template>
  <div>
    <el-row>
      <el-col>
        <section class="dashboard-card">
          <h5 class="card-title">Parts</h5>
          <div class="card-body pb-2">
            <div class="card-holder">
              <el-card class="box-card box-success">
                <div class="box-content__wrapper">
                  <h6 class="box-header">Pending</h6>
                  <router-link
                    v-if="user.isRole([1, 4, 7])"
                    :to="{ name: 'dashboard_pending' }"
                  >
                    <span class="box-content">{{ statusCount(1) }}</span>
                  </router-link>
                  <span class="box-content" v-else>{{ statusCount(1) }}</span>
                </div>
              </el-card>
              <el-card class="box-card box-info">
                <div class="box-content__wrapper">
                  <h6 class="box-header">Completed - Awaiting Delivery</h6>
                  <router-link
                    v-if="user.isRole([1, 4, 7])"
                    :to="{ name: 'dashboard_completed' }"
                  >
                    <span class="box-content">{{ statusCount(2) }}</span>
                  </router-link>
                  <span class="box-content" v-else>{{ statusCount(2) }}</span>
                </div>
              </el-card>
              <el-card class="box-card box-primary">
                <div class="box-content__wrapper">
                  <h6 class="box-header">Total</h6>
                  <span class="box-content">{{ totalCount }}</span>
                </div>
              </el-card>
            </div>
          </div>
        </section>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <router-view></router-view>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "SupervisorDashboard",
  data: () => ({}),
  computed: {
    user() {
      return this.$store.getters["auth/user"];
    },
    cardData() {
      return this.$store.getters["dashboard/cardData"];
    },
    totalCount() {
      if (!this.cardData.length) return 0;
      return this.cardData.reduce((p, c) => p + c.count, 0);
    }
  },
  watch: {
    user: function(v) {
      this.$store.dispatch("dashboard/getCustomers");
      this.$store.dispatch("dashboard/jo_status");
    }
  },
  methods: {
    statusCount(type) {
      let data = this.cardData.find(o => o.status_category == type);
      if (data) return data.count;
      return 0;
    }
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
a,
.router-link-active {
  color: #fff;
}
</style>
